import { render, staticRenderFns } from "./TalentWelcome.vue?vue&type=template&id=66485ec5"
import script from "./TalentWelcome.vue?vue&type=script&lang=js"
export * from "./TalentWelcome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports